import { useState, useEffect, useMemo } from 'react';
import CalendarIcon from '@/assets/icons/reports/Calendar';
import { MenuSelect } from '../menu-select';
import { getOptions, defaultOptions } from '../utils/date-group';

export const DateGroup = ({
  timeframe = {},
  selected = null,
  onChange = () => {},
}) => {
  const [currSelected, setSelected] = useState(defaultOptions[0]);
  const onSelect = (option) => {
    setSelected(option);
    onChange(option);
  };

  const options = useMemo(() => {
    const options = getOptions({ ...timeframe });
    return options;
  }, [timeframe]);

  useEffect(() => {
    const currSelected = options?.find((option) => option.id === selected);
    if (selected && currSelected) {
      setSelected(currSelected);
      return;
    }
    setSelected(options[0]);
  }, [selected, options]);

  return (
    <MenuSelect
      options={options}
      selected={currSelected}
      onSelect={onSelect}
      icon={CalendarIcon}
      prefix="View by"
      styles={{ menuList: { zIndex: 20 } }}
    />
  );
};
